import Seo from "../components/Seo";
import ServiceCard from "../components/ServiceCard";
import CtaBand from "../components/CtaBand";
import { Reveal, Eyebrow } from "../components/Reveal";
import { SITE, SERVICES } from "../data/site";

export default function ServicesIndex() {
  return (
    <>
      <Seo
        title="Security Services England | 17 Specialist Services | Xtreme Protection England"
        description="17 specialist security services across England: manned guarding, door supervision, CCTV monitoring, mobile patrols, event security, K9 units, key holding & more. SIA licensed, 24/7."
        keywords={SERVICES.flatMap((s) => s.keywords).join(", ")}
        canonical={`${SITE.domain}/services`}
      />

      <section className="tactical-grid border-b border-white/10" data-testid="services-hero">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
          <Reveal>
            <Eyebrow>The Arsenal // 17 Specialist Services</Eyebrow>
            <h1 className="font-display font-black uppercase leading-[0.95] tracking-tight text-5xl sm:text-6xl lg:text-7xl text-white max-w-4xl">
              Security services across England
            </h1>
            <p className="mt-6 max-w-2xl text-base sm:text-lg text-gray-300 leading-relaxed">
              Every service below is delivered by SIA-licensed, BS 7858 vetted
              officers and coordinated by our 24/7 England command centre. Each
              service page maps coverage across all{" "}
              <span className="text-amber font-semibold">120+ England locations</span> we
              protect.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-testid="services-grid-section">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="services-grid">
          {SERVICES.map((svc, i) => (
            <Reveal key={svc.slug} delay={(i % 4) * 0.05}>
              <ServiceCard svc={svc} index={i} />
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBand
        title="Not sure which service fits your risk?"
        text="Speak to our England command centre. We will assess your site, recommend only what you need, and put it in writing — free and without obligation."
      />
    </>
  );
}
